module.exports = __webpack_public_path__ + "static/008111-84b1ee8d498c8c3061ffdfe74c7f9b81.jpg";